module.exports = __webpack_public_path__ + "static/tfc-cc451763d130e9ac6adf68232269ae57.jpg";